import { BaseModel } from "../base.model";
import { InvoiceLineItem } from "./invoice-line-item.model";

export class InvoiceModel extends BaseModel{
    number?: string;
    requisitionId?:	string;
    requisitionNumber?: string;
    requisitionType?: string;
    clientId?: string;
    clientName?: string;
    clientAddress?: string;
    accountId?: string;
    accountCompanyName?: string;
    accountAddress?: string;
    claimNumber?: string;
    matterNumber?: string;
    userId?: string; // Witness Id - person who made the requisition
    userFullName?: string; // Witness Name - person who made the requisition
    myFileId?: string;
    lineItems: InvoiceLineItem[] = [];
    processingFee?: number;
    additionalFee?: number;
    price?: number;
    calculateTax?:	boolean
    processingFeeHST?: number;
    processingFeeTotal?: number;
    chequePrice?: number;
    hst?: number;
    subTotal?: number;
    total?: number;
    amountInWords?: string;
    centsPart?: string;
    accountFullName?: string;
}